import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { NavLink as RouterLink } from "react-router-dom";
import { Button, Collapse, ListItem, Typography } from "@mui/material";
import { useNavItemData } from "./NavItemData";
import "./index.scss";

const NavItem = ({
  children,
  className,
  depth,
  href,
  icon: Icon,
  info: Info,
  open: openProp,
  title,
  isCollapsed,
  ...rest
}) => {
  const { open, handleToggle } = useNavItemData(openProp);

  if (children) {
    return (
      <ListItem
        className={`nav-item ${className || ""}`}
        disableGutters
        key={title}
        {...rest}
      >
        <Button className="nav-item__button" onClick={handleToggle}>
          {Icon && <Icon className="nav-item__icon" />}
          <Typography className="nav-item__title">{title}</Typography>
          {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </Button>
        <Collapse in={open}>{children}</Collapse>
      </ListItem>
    );
  }

  return (
    <ListItem
      className={`nav-item nav-item--leaf ${
        isCollapsed ? "nav-item--collapsed" : ""
      } ${className || ""} depth-${depth}`}
      disableGutters
      key={title}
      {...rest}
    >
      <Button
        exact
        to={href}
        className="nav-item__button-leaf"
        component={RouterLink}
        title={isCollapsed ? title : ""}
      >
        {Icon && <Icon className="nav-item__icon-leaf" />}
        {!isCollapsed && (
          <Typography className="nav-item__title-leaf">{title}</Typography>
        )}
        {Info && <Info />}
      </Button>
    </ListItem>
  );
};

export default NavItem;
